import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyledFooter } from "./styled";
export var Footer = function () {
    return _jsxs(StyledFooter, { children: [_jsx("p", { style: { fontSize: '12px' }, children: "The survey is confidential. Your individual responses will not be shared." }), _jsx("p", { style: { fontSize: '12px' }, children: "\u00A9 2026 BESIX Group. All rights reserved." })] });
};
